import React from "react"

import {IonButton, IonIcon} from "@ionic/react"
import {keyOutline, keySharp} from "ionicons/icons"

import User from "@customTypes/User"
import {useHistory} from "react-router";

interface props {
    item: User
}

const ListItemButtonKeys: React.FC<props> = ({item}) => {

    const history = useHistory()
        , keysUsed = item.counts?.keysUsed !== null ? item.counts?.keysUsed : '?'
        , keysMax = item.maxKeys !== null ? item.maxKeys : '?'

    const goToUserView = (ev: any, userId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/users/' + userId)
    }

    return (
        <IonButton color="medium" fill="clear" size="large"
                   onClick={ (ev) => goToUserView(ev, item.id) }
                   style={{ 'minWidth': '100px', 'fontSize': '1rem' }}>
            <IonIcon slot="start" ios={keyOutline} md={keySharp} />
            {keysUsed}/{keysMax}
        </IonButton>
    )
}

export default ListItemButtonKeys